import { setCurrentScriptHostAsCdnDomain } from '@office-start/webpack-utility';
// Set cdn domain
setCurrentScriptHostAsCdnDomain();
